<template>
  <YdDialog
    :title="title"
    :visible.sync="showVisible"
    append-to-body
    @close="closeEdit"
    width="60%"
    @open="openEdit"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      style="margin-left: 30px; margin-right: 10px"
      size="mini"
      label-position="left"
      label-width="100px"
    >
      <div class="title-box">基本信息</div>
      <el-form-item label="活动名称" prop="name">
        <el-input
          type="text"
          placeholder="不超过10个字"
          v-model="form.name"
          maxlength="10"
          show-word-limit
          style="width: 300px"
        />
      </el-form-item>
      <el-form-item label="隶属公司" prop="merchantId">
        <YdMerchantSelector
          v-model="form.merchantId"
          styles="width: 300px"
          placeholder="请选择隶属公司"
        />
      </el-form-item>
      <el-form-item label="活动时间" required>
        <el-date-picker
          v-model="form.startTime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="开始日期"
          :picker-options="pickerOptionStart()"
          style="width: 200px"
        />
        <span> - </span>
        <el-date-picker
          v-model="form.endTime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="结束日期"
          :picker-options="pickerOptionEnd()"
          style="width: 200px"
        />
      </el-form-item>
      <div class="title-box">乘客端展示</div>
      <el-form-item label="活动头图" prop="headImgUrl" required>
        <el-upload
          ref="uploadRef"
          :action="doUpload"
          :headers="headers"
          name="file"
          list-type="picture-card"
          :before-upload="(file) => handleBeforeUpload(file, 750)"
          :on-success="
            (response, file, fileList) => {
              return uploadSuccess(response, file, fileList)
            }
          "
          :on-error="handleUploadError"
          :on-remove="handleRemove"
          :file-list="fileList"
          :show-file-list="true"
          style="width: 100%"
          :data="{ code: 'activity' }"
          :class="{ disabled: uploadDisabled }"
        >
          <i class="el-icon-plus"></i>
          <div class="el-upload__tip" slot="tip">jpg/png格式，宽度750，不超过500kb。</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="活动背景色" prop="backcolor">
        <el-input
          type="text"
          placeholder="请填入色值，如#080808"
          v-model="form.backcolor"
          show-word-limit
          style="width: 300px"
        />
      </el-form-item>
      <el-form-item label=" 活动规则" prop="rule">
        <rich-text-editor v-model="form.rule" />
      </el-form-item>
      <div style="display: flex; justify-content: space-between; align-items: center">
        <div class="title-box">活动奖励</div>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAddCoupon"
          size="mini"
          >添加优惠券/礼包</el-button
        >
      </div>
      <div style="padding-top: 10px">
        <el-table :data="couponItem" border size="mini" max-height="280px">
          <el-table-column label="序号" type="index" width="50" align="center" />
          <el-table-column label="优惠券名称" align="center" prop="name" />
          <el-table-column label="所属礼包" align="center" prop="giftName" />
          <el-table-column label="金额/个" align="center" prop="discountsMoney" width="80" />
          <el-table-column label="剩余数量" align="center" prop="surplusNum" width="100" />
          <el-table-column label="每次领取数量" align="center" prop="num">
            <template slot-scope="scope">
              <avue-input-number v-model="scope.row.num" min-rows="0" style="width: 8vw" />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="deletes(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin: 10px 0"
        >每人限领
        <el-input
          type="number"
          v-model.number="form.everyPersonTime"
          style="width: 80px"
          size="mini"
        />
        次
      </div>
      <el-form-item label="可参与人次" prop="personTime" required>
        <div v-if="!isEdit">
          <el-input
            type="number"
            placeholder="请输入整数"
            v-model.number="form.personTime"
            style="width: 110px"
          />
          <div class="tipsBox">
            <image
              style="vertical-align: middle; width: 20px; height: 20px"
              src="./static/tips.png"
            />
            <span>本次活动可供用户领取的总次数，根据可领取用户数填写！</span>
          </div>
        </div>
        <div v-else style="display: flex">
          <el-descriptions
            :column="2"
            border
            direction="vertical"
            style="width: 200px"
            size="mini"
            :contentStyle="rowCenter"
            :labelStyle="rowCenter"
          >
            <el-descriptions-item label="总量">{{ form.personTime }}</el-descriptions-item>
            <el-descriptions-item label="剩余">{{ form.surplus }}</el-descriptions-item>
          </el-descriptions>
          <div style="display: flex; flex-direction: column; margin-left: 10px">
            <el-button
              type="primary"
              @click="isAddPersonTime = !isAddPersonTime"
              size="mini"
              style="width: 60px"
              >添加</el-button
            >
            <el-input
              v-if="isAddPersonTime"
              type="number"
              placeholder="请输入整数"
              v-model.number="form.addPersonTime"
              style="width: 110px; margin-top: 10px"
            />
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeEdit">取 消</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
    </div>
    <select-coupon ref="selectCoupon" v-if="selectVisible" @getCouponItem="getCouponItem" />
  </YdDialog>
</template>

<script>
  import RichTextEditor from '@/components/RichTextEditor/RichTextEditor'
  import env from '@/config/env'
  import { getToken } from '@/util/auth'
  import SelectCoupon from '../../components/sendcoupon/select-coupon'
  import dayjs from 'dayjs'
  import { isEmpty } from 'lodash-es'

  export default {
    components: {
      SelectCoupon,
      RichTextEditor
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      advertisingInfo: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        showVisible: false,
        selectVisible: false,
        doUpload: env.uploadUrl + env.ferryUrl + '/oss/uploadV2',
        // doUpload: 'https://custom-pre.ayundi.cn' + env.ferryUrl + '/oss/uploadV2',
        headers: {
          Authorization: 'Bearer ' + getToken()
        },
        rules: {
          name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
          backcolor: [{ required: true, message: '请输入活动背景色', trigger: 'blur' }],
          merchantId: [{ required: true, message: '请选择隶属公司', trigger: 'change' }],
          addPersonTime: [{ required: true, message: '请输入可参与人次', trigger: 'blur' }],
          personTime: [{ required: true, message: '请输入可参与人次', trigger: 'blur' }],
          headImgUrl: [{ required: true, message: '请上传活动头图', trigger: 'blur' }]
        },
        form: {
          name: '',
          merchantId: '',
          startTime: '',
          endTime: '',
          headImgUrl: '',
          backcolor: '',
          rule: '',
          couponRelationVos: [],
          everyPersonTime: '',
          personTime: '',
          addPersonTime: 0,
          type: 1
        },
        uploadDisabled: false,
        couponItem: [],
        isEdit: false,
        isAddPersonTime: false,
        title: '新建活动'
      }
    },
    mounted() {
      this.showVisible = this.visible
      if (!isEmpty(this.advertisingInfo)) {
        this.title = '编辑'
        this.isEdit = true
        this.uploadDisabled = true
        this.fileList = [{ url: this.advertisingInfo.headImgUrl }]
        this.form = {
          ...this.advertisingInfo,
          type: 1
        }
        if (!isEmpty(this.advertisingInfo.couponInfoList)) {
          this.advertisingInfo.couponInfoList.forEach((item) => {
            item.name = item.couponName
          })
          this.couponItem = this.advertisingInfo.couponInfoList
        }
      }
    },
    methods: {
      pickerOptionStart() {
        const s = dayjs().second()
        const m = dayjs().minute()
        const h = dayjs().hour()
        return {
          // 日期限制
          disabledDate: (time) => {
            return Date.now() - 3600 * 1000 * 24 > time.getTime()
          },
          // 时间限制
          selectableRange: h + ':' + m + ':' + s + '- 23:59:59'
        }
      },
      pickerOptionEnd() {
        if (!this.form.startTime) {
          return
        }
        const s = dayjs(this.form.startTime).second()
        const m = dayjs(this.form.startTime).minute()
        const h = dayjs(this.form.startTime).hour()
        return {
          // 日期限制
          disabledDate: (time) => {
            return time.getTime() < new Date(this.form.startTime).getTime() - 86400000
          },
          // 时间限制
          selectableRange: h + ':' + m + ':' + s + '- 23:59:59'
        }
      },
      handleAddCoupon() {
        this.selectVisible = true
        this.$nextTick(() => {
          this.$refs.selectCoupon.init()
        })
      },
      handleBeforeUpload(file, imgWidth) {
        return new Promise((resolve, reject) => {
          const uploadTypes = ['jpg', 'jpeg', 'png', 'gif']
          const filetype = file.name.replace(/.+\./, '')
          if (uploadTypes.indexOf(filetype.toLowerCase()) === -1) {
            this.$message.warning({
              message: '请上传后缀名为jpg、jpeg、png、gif的附件'
            })
            reject(new Error())
          }
          this.getImgSize(file).then((res) => {
            const { width } = res
            if (width !== imgWidth) {
              this.$message.warning({
                message: '尺寸不符，请修改尺寸后重新上传！'
              })
              this.uploadDisabled = false
              reject(new Error())
            } else {
              this.$loading()
              this.uploadDisabled = true
              resolve()
            }
          })
          // this.$loading()
          // this.uploadDisabled = true
        })
      },
      uploadSuccess(res, file, fileList, type) {
        this.$loading().close()
        if (JSON.stringify(res.data) === '{}') {
          this.$message.warning({
            message: '请修改文件名后重新上传'
          })
          const index = this.$refs.uploadRef.uploadFiles.findIndex((e) => e.uid === file.uid)
          this.$refs.uploadRef.uploadFiles.splice(index, 1)
          this.uploadDisabled = false
          return
        }
        this.form.headImgUrl = res.data.url
      },
      // 上传失败
      handleUploadError() {
        this.$loading().close()
        this.$modal.msgError('上传失败，请重试')
        this.uploadDisabled = false
      },
      handleRemove(file, fileList) {
        this.form.headImgUrl = ''
        this.uploadDisabled = false
      },
      save() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            if (!this.form.startTime || !this.form.endTime) {
              this.$message.info('请先选择活动时间！')
              return
            }
            if (!this.form.headImgUrl) {
              this.$message.info('请上传活动头图！')
              return
            }
            this.form.couponRelationVos = this.couponItem.map((item) => {
              return {
                couponId: item.id || item.couponId,
                type: item.type,
                num: item.num
              }
            })
            if (this.isEdit) {
              delete this.form.personTime
            }
            this.$emit('saveEdit', this.form)
          }
        })
      },
      closeEdit() {
        this.uploadDisabled = false
        this.form = {
          name: '',
          merchantId: '',
          startTime: '',
          endTime: '',
          headImgUrl: '',
          backcolor: '',
          rule: '',
          couponRelationVos: [],
          everyPersonTime: '',
          personTime: '',
          addPersonTime: 0,
          type: 1
        }
        this.showVisible = false
        this.isEdit = false
        this.isAddPersonTime = false
        this.couponItem = []
        this.$emit('closeEdit')
      },
      getImgSize(imgFile) {
        return new Promise((resolve) => {
          const reader = new FileReader()
          reader.readAsDataURL(imgFile)
          reader.onload = function () {
            const image = new Image()
            image.src = reader.result
            image.onload = function () {
              resolve({
                width: this.width,
                height: this.height,
                src: this.src
              })
            }
          }
        })
      },
      deletes(index) {
        this.couponItem.splice(index, 1)
      },
      getCouponItem(couponItem) {
        this.couponItem.push(...couponItem)
        this.couponItem = this.couponItem.filter((item, index, self) => {
          return self.findIndex((el) => el.id === item.id) === index
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title-box {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }

  .tipsBox {
    display: inline-block;
    font-size: 13px;
    color: #9f9f9f;
    margin-left: 10px;
  }

  .disabled ::v-deep .el-upload--picture-card {
    display: none;
  }

  .disabled ::v-deep .el-upload__tip {
    margin-top: -10px;
  }
</style>
